import axiosInstance from "../../interceptors/axiosInstance";
import { getSessionData } from "../../interceptors/localStorageService";
import { getApiBaseUrl } from "../../../shared/config/tenantConfiguration";
import { SelfUserClassificationEnum } from "../../../shared/constants/constants";

// Dynamically get baseUrl for each request to support tenant switching
const getBaseUrl = () => getApiBaseUrl();

const PUBLIC_ROUTES = [
  '/authentication/login',
  '/authentication/admin/login',
  '/authentication/register',
  '/authentication/forgot-password',
];


const isPublicRoute = () => {
  const currentPath = window.location.pathname;
  return PUBLIC_ROUTES.some(route => currentPath.includes(route));
};

// Function to make a post request
export const postRequest = async (command, data, language) => {
  let endpoint = "/api/bpm/cmd";
  if (language) {
    endpoint = endpoint.concat("?lang=").concat(language);
  }

  const dataToSend = {
    cmd: command,
    data: JSON.stringify(data),
  };

  try {
    const response = await axiosInstance.post(endpoint, dataToSend);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const postRequestSimulator = async (command, data) => {
  let endpoint = "/api/bpm/selfservice/cmd";
  
  const dataToSend = {
    cmd: command,
    data,
  };

  // var sessionData = getSessionData();
  try {
    const response = await axiosInstance.post(endpoint, dataToSend);
    return response.data;
  } catch (error) {
    // console.log("error", error);
    // console.log("error.response", sessionData);

    return Promise.reject(error);
  }
};
let _isHandlingAuthFailure = false;
// Function to make an authenticated post request with `language` passed as an argument
export const postAuthenticatedRequest = async (
  command,
  data,
  isBackOffice = false
) => {
  let endpoint = isBackOffice
    ? "/api/core/backoffice/cmd"
    : "/api/bpm/selfservice/cmd";
  // if (language) {
  //   endpoint.concat("?lang=").concat(language);
  // }
  const dataToSend = {
    cmd: command,
    data: JSON.stringify(data),
  };

  // var sessionData = getSessionData();
  try {
    const response = await axiosInstance.post(endpoint, dataToSend);
// Simulate logout    throw { response: { status: 401, data: { message: 'Simulated 401 for testing' } } };

    return response.data;
  } catch (error) {
    //  console.log("error", error);
    // console.log("error.response", sessionData);
    
     const statusCode = error?.response?.status;
    if (statusCode === 401) {

      // ✅ Check if already on public route
      if (isPublicRoute()) {
        console.log('[postAuthenticatedRequest] 401 on public route, skipping event dispatch');
        
        const authError = new Error('');
        authError.statusCode = 401;
        authError.originalError = error;
        return Promise.reject(authError);
      }

      // only dispatch once for a burst of 401s
       console.log("_isHandlingAuthFailure", _isHandlingAuthFailure);
        if (!_isHandlingAuthFailure)
         {
        _isHandlingAuthFailure = true;
         const sessionData = getSessionData() || {};
         const isAdmin =
             sessionData?.userClassification ===
             SelfUserClassificationEnum.BACKOFFICE_ADMINISTRATORS.value;
             
         let loginRoute = isAdmin? "/authentication/admin/login" : "/authentication/login";

          console.log("Dispatching auth:expired event");
        window.dispatchEvent(new CustomEvent("auth:expired", {
          detail: { message: "Your session has expired. The application will log you out.", loginRoute }
        }));
        // allow future expiry events after a grace period
        setTimeout(() => { _isHandlingAuthFailure = false; }, 8000);
      }
     // Create a real Error instance so React/components don't try to render a plain object
      const authError = new Error('');//ensure no message so that calling code can check statusCode
      authError.statusCode = 401;
      authError.originalError = error;
      return Promise.reject(authError);
    }

   // For non-401, normalize to Error instance as well (optional)
    if (!(error instanceof Error)) {
      const norm = new Error(error?.message || "Request failed");
      norm.originalError = error;
      return Promise.reject(norm);
    }
    return Promise.reject(error);
  }
};
